import { SET_LOGIN_USER, SET_LOGIN_FLAG, SET_COUNTRY, SET_LOGINUSERTYPE} from '../types/types';

export const setLoginUser = (value) => {
  return {
    type: SET_LOGIN_USER,
    payload: { data: value },
  };
};

export const setLoginFlag = (value) => {
  return {
    type: SET_LOGIN_FLAG,
    payload: { data: value },
  };
};

export const setCountry = (value) => {
  return {
    type: SET_COUNTRY,
    payload: { data: value },
  };
};

export const setLoginUserType = (value) => {
  return {
    type: SET_LOGINUSERTYPE,
    payload: { data: value },
  };
};
